// Footer.js
export default function Footer() {
    return null;
  }
  
